import { t } from 'i18next'
import React from 'react'

import { BaseModalType } from '@context/ModalsContext'

import { SearchFieldProps } from '@ui/SearchField/SearchField'
import { Input } from '@ui/components/Input'
import { Modal } from '@ui/components/Modal'
import { CloseIcon } from '@ui/icons/Close.icon'
import { SearchIcon } from '@ui/icons/Search.icon'

import { Loading } from '@shared/components/Loading/Loading'

interface SearchModalProps extends SearchFieldProps {
  handleClear: () => void
  handleChange(event: React.ChangeEvent<HTMLInputElement>): void
}

export const SearchModal: BaseModalType<SearchModalProps> = (props) => {
  const {
    close,
    label,
    value,
    disabled,
    canClear,
    handleClear,
    handleChange,
    isLoading = false,
    renderResult,
  } = props

  const labelText = label ?? t('Search')

  return (
    <Modal.FullScreen>
      <Modal.Header>{t('Search')}</Modal.Header>
      <Modal.Body>
        <Input
          label={labelText}
          value={value ?? ''}
          disabled={disabled}
          fullWidth
          leftIcon={SearchIcon}
          rightIcon={canClear && (value?.length ?? 0) > 0 ? CloseIcon : undefined}
          onEndIconClick={handleClear}
          onChange={handleChange}
        />
        <Loading fullWidth showLoadingIcon isLoading={isLoading}>
          {renderResult?.()}
        </Loading>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal.FullScreen>
  )
}
